import { createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import * as TanstackQuery from "./integrations/tanstack-query/root-provider";
import { initSentryClient } from "./lib/sentry";
import { routeTree } from "./routeTree.gen";

if (typeof window !== "undefined") {
  initSentryClient();
}

export const getRouter = () => {
  const rqContext = TanstackQuery.getContext();
  const router = createRouter({
    routeTree,
    context: { ...rqContext },
    defaultPreload: false,
    Wrap: (props: { children: React.ReactNode }) => {
      return <TanstackQuery.Provider {...rqContext}>{props.children}</TanstackQuery.Provider>;
    },
  });
  setupRouterSsrQueryIntegration({ router, queryClient: rqContext.queryClient });
  return router;
};
